import { render, staticRenderFns } from "./ReportSidebar.vue?vue&type=template&id=832e1984"
import script from "./ReportSidebar.vue?vue&type=script&lang=js"
export * from "./ReportSidebar.vue?vue&type=script&lang=js"
import style0 from "./ReportSidebar.vue?vue&type=style&index=0&id=832e1984&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports